// hooks/usePOIs.ts

import { useEffect, useState } from 'react'
import { getMapData } from '@mappedin/mappedin-js'
import { MIOptions, POI } from 'lib/utils/mappedin'

export function useMappedInPOIs(options: MIOptions | null | undefined) {
  const [pois, setPOIs] = useState<POI[]>([])

  useEffect(() => {
    const fetchPOIs = async () => {
      try {
        if (!options) return
        const mapData = await getMapData(options)
        const locations = mapData.getByType('point-of-interest')
        console.log('~~locations:', locations)

        const parsed: POI[] = locations
          .map((loc: any) => {
            // const position = loc.anchorTarget?.position || loc.focusTarget?.position
            const floorId = loc.floorId || loc.floor?.id || null

            if (!floorId) return null

            return {
              id: loc.id,
              name: loc.name,
              floorId,
              spaceId: null, // resolve later via raycast
              coordinates: {
                lat: loc.coordinate.latitude,
                long: loc.coordinate.longitude,
                floorId: loc.coordinate.floorId ?? 0,
              },
            }
          })
          .filter(Boolean) as POI[]

        setPOIs(parsed)
        console.log('~~parsed POIs:', parsed)
      } catch (err) {
        console.error('Failed to load Mappedin POIs:', err)
      }
    }

    if (options) fetchPOIs()
  }, [options])

  return pois
}
